export default {
  collection: '',
  collections: [],
  fields: '',
  models: []
}
